export default __webpack_public_path__ + "static/media/hostfully_step4.aa2961a9.png";